export const DRAWER_STATE = {
  DOCKED: "DRAWER_DOCKED",
  FLOATING: "DRAWER_FLOATING",
  HIDDEN: "DRAWER_HIDDEN"
};

export const CLOSE_DRAWER = "CLOSE_DRAWER";
export const OPEN_DRAWER = "OPEN_DRAWER";
export const SET_WIDTH = "SET_WIDTH";

export const openDrawer = () => ({
  type: OPEN_DRAWER
});

export const closeDrawer = () => ({
  type: CLOSE_DRAWER
});

export const setWidth = width => ({
  type: SET_WIDTH,
  width: width
});



// WEBPACK FOOTER //
// ./src/actions/drawer.js